import React, { useState } from "react";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { MenuItem, Box } from "@mui/material";
import { Link } from "react-router-dom";

import EntriesId from "../EntriesIdWithPrefix";
import ExtendOrCreateGroup from "../ExtendOrCreateTrader";
import { useAdminProviderDataContext } from "../../../../context";
interface IProps {
  complianceTraderId: number;
  isDisableEdit: boolean;
}

const AddAccountInGroup = ({ complianceTraderId, isDisableEdit }: IProps): React.ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        "& svg": {
          opacity: 0,
          visibility: "hidden",
          transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
          ml: "10px",
          cursor: "pointer",
        },
        "&:hover svg": {
          opacity: 1,
          visibility: "visible",
        },
      }}
    >
      <MenuItem component={Link} to={`fundedCompliance/${complianceTraderId}`}>
        <EntriesId entriesId={complianceTraderId} />
      </MenuItem>
      {allowed_features.access_edit_compliance_entries && isDisableEdit && (
        <>
          <ExtendOrCreateGroup isOpen={isOpen} setIsOpen={setIsOpen} groupId={complianceTraderId} />
          <PersonAddIcon color="primary" fontSize="medium" onClick={() => setIsOpen(true)} />
        </>
      )}
    </Box>
  );
};

export default AddAccountInGroup;
